import styled from 'styled-components';
export var Button = styled.button.withConfig({
  displayName: "Volumestyles__Button",
  componentId: "sc-1jl2dul-0"
})(["display:flex;justify-content:center;align-items:center;height:2rem;width:2rem;border:0px;color:inherit;cursor:pointer;font-family:inherit;padding:0px;margin:0.5rem;background:none;&:focus:not(:focus-visible){outline:none;}"]);